import StatusMessage from 'components/OrderConfirmation/SddSections/SddSection/StatusMessage/StatusMessage';
import withStatusMessageProps from 'viewModel/orderConfirmation/sddSections/sddSection/withStatusMessageProps';

const ConnectedStatusMessage = withStatusMessageProps(StatusMessage);

export default ConnectedStatusMessage;
